module.exports = __webpack_public_path__ + "img/d105002.svg";